<template>
  <div style="height: 100%">
    <div style="height: calc(100% - 50px); position: relative">
      <headerr :customBack="true" @back="back" class="_header">
        Gestisci operatori
      </headerr>
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    back() {
      if (this.$route.params.id) {
        this.$router.push("/operatori");
      } else {
        this.$router.push("/home");
      }
    }
  },
  computed: {},
  created() {
    this.$store.dispatch("operatori/recuperaOperatori");
  }
};
</script>

<style scoped></style>
